import { Field, Formik } from "formik";
import React, { useState } from "react";
import {
  ConfigureCommunicationField,
  FieldButtonGroup,
  WithDrawalCard,
  SliderPanel,
  FormLeaveGuard,
  FieldMultiSelectButtonGroup,
} from "../../../components";
import Table from "../../../components/CsplTable/CsplTable";

import { faEdit } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Button } from "react-bootstrap";
import SourceandInvestmentHierarchy from "./SourceandInvestmentHierarchy";
import InvestmentHierarchy from "./InvestmentHierarchy";
import { get, isEmpty } from "lodash";
import { toOptionValuesFromMapper } from "../../../utils";
import {
  SourceAllocationCalculationMethod,
  SourceAllocationCalculationMethodOptions,
} from "./DistributionConstantsAndFunctions";

const HIERARCHY_OPTIONS = [
  {
    label: "Source",
    value: 1,
  },
  {
    label: "Investment",
    value: 2,
  },
];
const sliderLabel = [
  { withdrawalamount: 9000, taxdeduction: 60, feededuction: 60 },
];
// const sourceAllocationOptions = [
//   {
//     label: "Pro-Rata",
//     value: 1,
//   },
//   {
//     label: "Hierarchy",
//     value: 3,
//   },
// ];

function SourceHierarchyComponent(props) {
  const {
    fields,
    setIsInnerFormDirty,
    setShowDirtyCheckModal,
    setSliderOpen,
    outerValues,
    setFieldValue,
    sliderOpen,
    isInnerFormDirty,
    onFormToggle,
    handleCancelClick,
    handleConfirmClick,
    showDirtyCheckModal,
    handleChange,
    employeePlans,
    selectedPlan,
    values,
    InvestDetails,
    selectedWithdrawalPlanSetUp,
    filteredSourceBalances,
    ...rest
  } = props;

  const onSubmit = (values) => {};
  let mappedPeriodicPaymentMethod = selectedWithdrawalPlanSetUp?.periodicPaymentMethod.map(
    (_) => (_ === 2 ? 3 : _)
  ); ///this has to be changes temporary fix
  const sourceAllocationOptions = toOptionValuesFromMapper(
    SourceAllocationCalculationMethodOptions
  ).filter((_) => mappedPeriodicPaymentMethod.includes(_.value));

  return (
    <div>
      <>
        <div className="d-flex mt-16">
          <Field
            isRequired
            name={fields.sourceAllocationCalculationMethod}
            label="Source allocation"
            size="sm"
            options={sourceAllocationOptions}
            selectedValue={values[fields.sourceAllocationCalculationMethod]}
            onChange={(value) => {
              setFieldValue(fields.sourceAllocationCalculationMethod, value);
            }}
            component={FieldButtonGroup}
          />
        </div>
      </>
      {values[fields.sourceAllocationCalculationMethod] ===
        SourceAllocationCalculationMethod.Hierarchy && (
        <>
          <Field
            isRequired
            size="sm"
            name={fields.hierarchyCalculationMethod}
            label={"Hierarchy setup"}
            options={HIERARCHY_OPTIONS}
            selectedValue={values[fields.hierarchyCalculationMethod]}
            value={values[fields.hierarchyCalculationMethod]}
            onChange={(value) => {
              setFieldValue(fields.hierarchyCalculationMethod, value);
              if (value.includes(1)) {
                setFieldValue(fields.investmentHierarchies, []);
                let sourceDetails = filteredSourceBalances.map((val, ind) => {
                  return {
                    ...val,

                    investmentHierarchies: val.sourceInvestmentBalances.map(
                      (i) => {
                        return {
                          investmentId: parseInt(i.investmentId),
                          hierarchyNumber: "",
                        };
                      }
                    ),
                    hierarchyNumber: get(
                      values,
                      `${fields.sourceHierarchyDetails}.${ind}.hierarchyNumber`,
                      ""
                    ),
                  };
                });
                setFieldValue(fields.sourceHierarchyDetails, sourceDetails);
              } else {
                setFieldValue(fields.sourceHierarchyDetails, []);
              }
            }}
            validate={(value) => {
              return [undefined, null, ""].includes(value)
                ? "Required"
                : undefined;
            }}
            component={FieldMultiSelectButtonGroup}
          />

          {values[fields.hierarchyCalculationMethod]?.length > 0 && (
            <div>
              {values[fields.hierarchyCalculationMethod]?.length === 1 &&
              values[fields.hierarchyCalculationMethod]?.[0] === 2 ? (
                <InvestmentHierarchy
                  values={values}
                  fields={fields}
                  selectedPlan={selectedPlan}
                  InvestDetails={InvestDetails}
                  setFieldValue={setFieldValue}
                  filteredSourceBalances={filteredSourceBalances}
                />
              ) : (
                <SourceandInvestmentHierarchy
                  values={values}
                  fields={fields}
                  selectedPlan={selectedPlan}
                  outerValues={outerValues}
                  setFieldValue={setFieldValue}
                  handleChange={handleChange}
                  filteredSourceBalances={filteredSourceBalances}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default SourceHierarchyComponent;
